import DependencyInjector from "./DependencyInjector";

/**
 *  Select2 Init (jQuery)
 *  params: - component (to load select2 module)
 *          - otherOptions
 *
 */
export const Select2Init = (otherOptions = {}) => {
  new DependencyInjector().loadSelect2AndExecute(
    () => {
      function formatOption(option) {
        // no icon
        if ($(option.element).data("icon") === undefined) {
          return $(`<span ${$(option.element).hasClass("unavailable") ? 'class="unavailable"' : ""}>
              ${option.text}
            </span>`);
        }
        return $(`<span ${$(option.element).hasClass("unavailable") ? 'class="unavailable"' : ""}>
            ${option.text}
            <i class="${$(option.element).data("icon")} --m"></i>
          </span>`);
      }

      function formatSelection(option) {
        // no icon
        if ($(option.element).data("message")) {
          return $(`<span>
              ${$(option.element).data("message")}
              ${option.text}
              <i class="icon-chevron-down --m"></i>
            </span>`);
        }

        return $(`<span>
            ${option.text}
            <i class="icon-chevron-down --m"></i>
          </span>`);
      }

      let options = {
        templateResult: formatOption,
        templateSelection: formatSelection,
      };

      // get custom options
      const $select = $("select.custom-select__select");
      const placeholder = $select.attr("data-placeholder");

      options = {
        ...options,
        ...otherOptions,
        ...(placeholder ? { placeholder: placeholder } : {}),
      };

      // init
      $select.select2(options);

      // Helper function to update aria attributes for accessibility
      function updateAriaAttributes($originalSelect, isExpanded = false) {
        const ariaLabel = $originalSelect.attr('aria-label');
        if (!ariaLabel) return;

        const $select2Container = $originalSelect.next('.select2-container');
        const $select2Selection = $select2Container.find('.select2-selection');
        
        // Get the selected option text
        const selectedOption = $originalSelect.find('option:selected');
        const selectedText = selectedOption.text().trim();
        
        // Get the localized "selected" text from the parent container's data attribute
        const $selectContainer = $originalSelect.closest('.custom-select');
        const selectionLabel = $selectContainer.attr('data-selection-label');
        
        // Create comprehensive aria-label that includes the selected value
        let fullAriaLabel = ariaLabel;
        if (selectedText && selectedText !== '') {
          fullAriaLabel = `${ariaLabel}, ${selectedText} ${selectionLabel}`;
        }
        
        // Apply all aria attributes
        $select2Selection.attr('aria-label', fullAriaLabel);
        $select2Selection.removeAttr('aria-labelledby');
        $select2Selection.attr('role', 'combobox');
        $select2Selection.attr('aria-expanded', isExpanded.toString());
        
        // Hide the visual text from screen readers to avoid duplication
        const $select2SelectedText = $select2Selection.find('.select2-selection__rendered');
        $select2SelectedText.attr('aria-hidden', 'true');
      }

      // Initialize aria attributes for all selects
      $select.each(function() {
        updateAriaAttributes($(this), false);
      });

      // events
      $select.on("select2:select", (elm) => {
        // elm.target = real select, contains array with options
        try {
          if ($(elm.target).length > 0) {
            // get select2
            const select2 = $(elm.target).parent().find(".select2-container .selection");
            // get select2 container
            const selectContainer = $(select2).find(".select2-selection.select2-selection--single");
            const placeholder = selectContainer.find(".select2-selection__placeholder");
            if (placeholder.length === 0) {
              // apply style class
              $(selectContainer).addClass("selected");
            }
            
            // Update aria attributes after selection
            updateAriaAttributes($(elm.target), false);
          }
        } catch (e) {
          console.warn('"select active" style application failed!', e);
        }
      });

      // Update aria attributes when select opens/closes
      $select.on("select2:open", (elm) => {
        try {
          updateAriaAttributes($(elm.target), true);
        } catch (e) {
          console.warn('aria-label preservation on open failed!', e);
        }
      });

      $select.on("select2:close select2:clear", (elm) => {
        try {
          updateAriaAttributes($(elm.target), false);
        } catch (e) {
          console.warn('aria-label preservation on close/clear failed!', e);
        }
      });

      // "on load" (no load event found..)
      $select.each((index, sel) => {
        // if a value is selected, trigger the change to update style
        $(sel)
          .children("option")
          .each((index, option) => {
            if (option.selected && !option.disabled) {
              $(sel).trigger("select2:select");
            }
          });
        
        // Force aria attributes update after everything is set up
        const ariaLabel = $(sel).attr('aria-label');
        if (ariaLabel) {
          setTimeout(() => {
            updateAriaAttributes($(sel), false);
          }, 100);
        }
      });
    },
    (error) => {
      console.error("failed to load select2", error.stack);
    },
  );
};
